// eslint-disable-next-line no-unused-vars
import React from 'react';
import fr from 'facet-rest';
import { pickWithPriority } from 'Helpers/Affordances';
import AccountOpeningAgreementForActivationTemplate
  from 'Views/Page/Content/Templates/WizardTemplates/AccountOpeningAgreementTemplate/AccountOpeningAgreementActivationTestComponent';
import AccountOpeningAgreementTemplate
  from 'Views/Page/Content/Templates/WizardTemplates/AccountOpeningAgreementTemplate/AccountOpeningAgreementComponent';

// eslint-disable-next-line no-unused-vars
const AccountOpeningAgreementTemplatePicker = ({ resource, ...rest }) => {
  return pickWithPriority(resource, [
    [fr.relationships.activationTest.name, <AccountOpeningAgreementForActivationTemplate resource={resource} {...rest} />],
  ], <AccountOpeningAgreementTemplate resource={resource} {...rest} />);
};

export default AccountOpeningAgreementTemplatePicker;
